import { Fragment } from 'react'
import { Link, useParams } from 'react-router'
import { GUIDE_SLUGS, type GuideSlug } from '../content/guideSlugs'
import { GUIDES } from '../content/guides'
import { guidePath } from '../content/slugs'
import { AdSlot } from '../features/ads/AdSlot'
import { AD_SLOTS } from '../lib/config'
import { breadcrumbLd, pageMeta } from '../lib/pageMeta'
import { Prose } from '../ui/Prose'
import type { Route } from './+types/guide'
import NotFound, { notFoundMeta } from './not-found'

const guideOf = (slug: string | undefined) =>
  (GUIDE_SLUGS as readonly string[]).includes(slug ?? '') ? GUIDES[slug as GuideSlug] : undefined

export function meta({ params }: Route.MetaArgs) {
  const guide = guideOf(params.slug)
  if (!guide) return notFoundMeta()
  const path = guidePath(guide.slug)
  return pageMeta({
    title: guide.title,
    description: guide.description,
    path,
    jsonLd: [
      breadcrumbLd([
        { name: 'Guides', path: '/guides' },
        { name: guide.title, path },
      ]),
    ],
  })
}

export default function GuidePage() {
  const guide = guideOf(useParams().slug)
  if (!guide) return <NotFound />
  const { Body } = guide
  const others = GUIDE_SLUGS.filter((s) => s !== guide.slug && GUIDES[s].group === guide.group)
  return (
    <Prose title={guide.title} lead={guide.lead} crumbs={[{ to: '/guides/', label: 'Guides' }]}>
      <Body />
      <h2>More guides</h2>
      <p>
        {others.map((s, i) => (
          <Fragment key={s}>
            {i > 0 && ' · '}
            <Link to={guidePath(s)}>{GUIDES[s].title}</Link>
          </Fragment>
        ))}
        . Or see <Link to="/guides/">all the guides</Link>.
      </p>
      <AdSlot slot={AD_SLOTS.content} />
    </Prose>
  )
}
